import { DealManagerDealComponent } from "@/features";

export const DealManagerDealPage = () => {
  return <DealManagerDealComponent />;
}